var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import NavigationService from "@ane/core/lib/services/NavigationService";
import LocalStorageService from "@ane/core/lib/services/LocalStorageService";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import { WORKSPACE_ID, SET_TREATMENT_VARIABLE } from "@ane/core/lib/constants/QueryString.constants";
import { IWorkspaceMigrationStatus } from "../../models/masterData/MdsDataplaneModels.js";
const stringCompareTo = (a, b) => {
  return a.localeCompare(b, void 0, { sensitivity: "accent" });
};
const getExperimentationGroupMigationData = (migrationData, experimentationGroupId = "", workspaceId) => !!migrationData ? [...migrationData].sort((a, b) => stringCompareTo(a.OldExperimentationGroupId, b.OldExperimentationGroupId)).reverse().find((data) => {
  return (experimentationGroupId === (data == null ? void 0 : data.OldExperimentationGroupId) || experimentationGroupId.startsWith(`${data == null ? void 0 : data.OldExperimentationGroupId}~`)) && data.OldWorkspaceId === workspaceId;
}) : void 0;
const getExpManExperimentationGroupMigationData = (migrationData, experimentationGroupId = "", workspaceId) => !!migrationData ? [...migrationData].sort((a, b) => stringCompareTo(a.OldExperimentationGroupId, b.OldExperimentationGroupId)).reverse().find((data) => {
  return (experimentationGroupId === (data == null ? void 0 : data.OldExperimentationGroupId) || experimentationGroupId.startsWith(`${data == null ? void 0 : data.OldExperimentationGroupId}~`)) && /**
  * Viewing entity in new workspace
  * Lookup by new workspaceId - ExPMan returns old experimentation group
  */
  data.NewWorkspaceId === workspaceId;
}) : void 0;
const getMigrationDataByNewExperimentationGroupId = (migrationData, experimentationGroupId = "", workspaceId) => !!migrationData ? [...migrationData].sort((a, b) => stringCompareTo(a.NewExperimentationGroupId, b.NewExperimentationGroupId)).reverse().find((data) => {
  return (experimentationGroupId === (data == null ? void 0 : data.NewExperimentationGroupId) || experimentationGroupId.startsWith(`${data == null ? void 0 : data.NewExperimentationGroupId}~`)) && data.NewWorkspaceId === workspaceId;
}) : void 0;
const getExpManMigrationDataByNewExperimentationGroupId = (migrationData, experimentationGroupId = "", workspaceId) => !!migrationData ? [...migrationData].sort((a, b) => stringCompareTo(a.NewExperimentationGroupId, b.NewExperimentationGroupId)).reverse().find((data) => {
  return (experimentationGroupId === (data == null ? void 0 : data.NewExperimentationGroupId) || experimentationGroupId.startsWith(`${data == null ? void 0 : data.NewExperimentationGroupId}~`)) && /**
  * Viewing entity in old workspace
  * Lookup by OLD workspaceId - ExPMan returns NEW experimentation group
  */
  data.OldWorkspaceId === workspaceId;
}) : void 0;
const enableEntityRedirects = (data) => {
  return isExperimentationGroupMigrated(data);
};
const enableGenericRedirects = (data) => {
  return (EnvironmentService.wsplitExpManGenericRedirects() ? isExpManMigrated(data) && isExperimentationGroupMigrating(data) && isAPICompatibilityEnabled(data) : isExperimentationGroupMigrating(data) && isAPICompatibilityEnabled(data)) || isExperimentationGroupMigrated(data);
};
const enableRedirectsWhenMDSMigrated = (data) => {
  return isMDSMigrated(data);
};
const enableRedirectsWhenExpManMigrated = (data) => {
  return isAPICompatibilityEnabled(data) && isExpManMigrated(data);
};
const isMDSMigrated = (data) => {
  return (data == null ? void 0 : data.MdsStatus) === IWorkspaceMigrationStatus.Migrated;
};
const isAPICompatibilityEnabled = (data) => {
  return (data == null ? void 0 : data.APICompatibility) === true;
};
const isExperimentationGroupMigrating = (data) => {
  return (data == null ? void 0 : data.MigrationStatus) === IWorkspaceMigrationStatus.Migrating;
};
const isExperimentationGroupPendingMigration = (data) => {
  return (data == null ? void 0 : data.MigrationStatus) === IWorkspaceMigrationStatus.PendingMigration;
};
const isExperimentationGroupMigrated = (data) => {
  return (data == null ? void 0 : data.MigrationStatus) === IWorkspaceMigrationStatus.Migrated;
};
const isExpManMigrated = (data) => {
  return (data == null ? void 0 : data.ExpManStatus) === IWorkspaceMigrationStatus.Migrated;
};
const handleEntityRedirects = (migrationData, experimentationGroupId, workspaceId) => {
  let data = void 0;
  data = getExperimentationGroupMigationData(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.NewWorkspaceId) !== workspaceId && enableEntityRedirects(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.NewWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.NewExperimentationGroupId,
      isRevertRedirect: false
    };
  }
  data = getMigrationDataByNewExperimentationGroupId(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.OldWorkspaceId) !== workspaceId && !enableEntityRedirects(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.OldWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.OldExperimentationGroupId,
      isRevertRedirect: true
    };
  }
  return { redirect: false, redirectWorkspaceId: void 0, experimentationGroupId: void 0, isRevertRedirect: false };
};
const handleGenericRedirects = (migrationData, experimentationGroupId, workspaceId) => {
  let data = void 0;
  data = getExperimentationGroupMigationData(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.NewWorkspaceId) !== workspaceId && enableGenericRedirects(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.NewWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.NewExperimentationGroupId,
      isRevertRedirect: false
    };
  }
  data = getMigrationDataByNewExperimentationGroupId(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.OldWorkspaceId) !== workspaceId && !enableGenericRedirects(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.OldWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.OldExperimentationGroupId,
      isRevertRedirect: true
    };
  }
  return { redirect: false, redirectWorkspaceId: void 0, experimentationGroupId: void 0, isRevertRedirect: false };
};
const handleMDSRedirects = (migrationData, experimentationGroupId, workspaceId) => {
  let data = void 0;
  data = getExperimentationGroupMigationData(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.NewWorkspaceId) !== workspaceId && enableRedirectsWhenMDSMigrated(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.NewWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.NewExperimentationGroupId,
      isRevertRedirect: false
    };
  }
  data = getMigrationDataByNewExperimentationGroupId(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.OldWorkspaceId) !== workspaceId && !enableRedirectsWhenMDSMigrated(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.OldWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.OldExperimentationGroupId,
      isRevertRedirect: true
    };
  }
  return { redirect: false, redirectWorkspaceId: void 0, experimentationGroupId: void 0, isRevertRedirect: false };
};
const handleExpManRedirects = (migrationData, experimentationGroupId, workspaceId) => {
  let data = void 0;
  data = getExpManMigrationDataByNewExperimentationGroupId(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.NewWorkspaceId) !== workspaceId && enableRedirectsWhenExpManMigrated(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.NewWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.NewExperimentationGroupId,
      isRevertRedirect: false
    };
  }
  data = getExpManExperimentationGroupMigationData(migrationData, experimentationGroupId, workspaceId);
  if ((data == null ? void 0 : data.OldWorkspaceId) !== workspaceId && !isExpManMigrated(data)) {
    return {
      redirect: true,
      redirectWorkspaceId: data == null ? void 0 : data.OldWorkspaceId,
      experimentationGroupId: data == null ? void 0 : data.OldExperimentationGroupId,
      isRevertRedirect: true
    };
  }
  return { redirect: false, redirectWorkspaceId: void 0, experimentationGroupId: void 0, isRevertRedirect: false };
};
const getWorkspaceMigrationRedirectURL = (props) => {
  const { redirectWorkspaceId, defaultPath = WindowLocation.pathname, defaultSearch = WindowLocation.search } = props;
  let workspaceMigrationRedirectUrl = void 0;
  if (!!redirectWorkspaceId) {
    const search = NavigationService.omitQueryParams([WORKSPACE_ID, SET_TREATMENT_VARIABLE], defaultSearch);
    workspaceMigrationRedirectUrl = NavigationService.addParamToHref({
      href: `${WindowLocation.origin}${defaultPath}${search}${WindowLocation.hash}`,
      param: WORKSPACE_ID,
      value: redirectWorkspaceId
    });
  }
  return workspaceMigrationRedirectUrl;
};
const OPG_SUPPORT_BANNER_KEY = "workspaceOPGSupportBanner";
const MIGRATION_REDIRECT_BANNERS_KEY = "workspaceMigrationBanners";
const MIGRATION_PENDINGMIGRATION_BANNERS_KEY = "workspacePendingMigrationBanners";
const MIGRATION_MIGRATING_BANNERS_KEY = "workspaceMigratingBanners";
const MIGRATION_WORKSPACE_SELECTION_KEY = "showWorkspaceSelectionTeachingBubble";
const showMigrationBannerOnRedirect = (workspaceId) => {
  const workspaceMigrationBanners = LocalStorageService.getItem(MIGRATION_REDIRECT_BANNERS_KEY);
  const value = __spreadValues({
    [workspaceId]: true
  }, workspaceMigrationBanners);
  LocalStorageService.setItem(MIGRATION_REDIRECT_BANNERS_KEY, value);
};
const hideMigrationBannerOnDismiss = (workspaceId) => {
  const workspaceMigrationBanners = LocalStorageService.getItem(MIGRATION_REDIRECT_BANNERS_KEY);
  const value = __spreadProps(__spreadValues({}, workspaceMigrationBanners), {
    [workspaceId]: false
  });
  LocalStorageService.setItem(MIGRATION_REDIRECT_BANNERS_KEY, value);
};
const showMigrationRedirectBanner = (workspaceId) => {
  var _a;
  return ((_a = LocalStorageService.getItem(MIGRATION_REDIRECT_BANNERS_KEY)) == null ? void 0 : _a[workspaceId]) === true;
};
const hideOPGBannerOnDismiss = (workspaceId) => {
  const workspaceMigrationBanners = LocalStorageService.getItem(OPG_SUPPORT_BANNER_KEY);
  const value = __spreadProps(__spreadValues({}, workspaceMigrationBanners), {
    [workspaceId]: false
  });
  LocalStorageService.setItem(OPG_SUPPORT_BANNER_KEY, value);
};
const showOPGSupportBanner = (workspaceId) => {
  var _a;
  return ((_a = LocalStorageService.getItem(OPG_SUPPORT_BANNER_KEY)) == null ? void 0 : _a[workspaceId]) === false;
};
const hidePendingMigrationBannerOnDismiss = (bannerId) => {
  const workspaceMigrationBanners = LocalStorageService.getItem(
    MIGRATION_PENDINGMIGRATION_BANNERS_KEY
  );
  const value = __spreadProps(__spreadValues({}, workspaceMigrationBanners), {
    [bannerId]: false
  });
  LocalStorageService.setItem(MIGRATION_PENDINGMIGRATION_BANNERS_KEY, value);
};
const showPendingMigrationBanner = (bannerId) => {
  var _a;
  return ((_a = LocalStorageService.getItem(MIGRATION_PENDINGMIGRATION_BANNERS_KEY)) == null ? void 0 : _a[bannerId]) !== false;
};
const hideMigratingBannerOnDismiss = (bannerId) => {
  const workspaceMigrationBanners = LocalStorageService.getItem(MIGRATION_MIGRATING_BANNERS_KEY);
  const value = __spreadProps(__spreadValues({}, workspaceMigrationBanners), {
    [bannerId]: false
  });
  LocalStorageService.setItem(MIGRATION_MIGRATING_BANNERS_KEY, value);
};
const showMigratingBanner = (bannerId) => {
  var _a;
  return ((_a = LocalStorageService.getItem(MIGRATION_MIGRATING_BANNERS_KEY)) == null ? void 0 : _a[bannerId]) !== false;
};
const showWorkspaceSelectionTeachingBubbleOnRedirect = () => {
  const workspaceSelectionTeachingBubble = LocalStorageService.getItem(MIGRATION_WORKSPACE_SELECTION_KEY);
  if (workspaceSelectionTeachingBubble !== false) {
    LocalStorageService.setItem(MIGRATION_WORKSPACE_SELECTION_KEY, true);
  }
};
const hideWorkspaceSelectionTeachingBubble = () => {
  LocalStorageService.setItem(MIGRATION_WORKSPACE_SELECTION_KEY, false);
};
const showWorkspaceSelectionTeachingBubble = () => LocalStorageService.getItem(MIGRATION_WORKSPACE_SELECTION_KEY) || false;
export {
  MIGRATION_MIGRATING_BANNERS_KEY,
  MIGRATION_PENDINGMIGRATION_BANNERS_KEY,
  MIGRATION_REDIRECT_BANNERS_KEY,
  MIGRATION_WORKSPACE_SELECTION_KEY,
  OPG_SUPPORT_BANNER_KEY,
  enableEntityRedirects,
  enableGenericRedirects,
  enableRedirectsWhenExpManMigrated,
  enableRedirectsWhenMDSMigrated,
  getExpManExperimentationGroupMigationData,
  getExpManMigrationDataByNewExperimentationGroupId,
  getExperimentationGroupMigationData,
  getMigrationDataByNewExperimentationGroupId,
  getWorkspaceMigrationRedirectURL,
  handleEntityRedirects,
  handleExpManRedirects,
  handleGenericRedirects,
  handleMDSRedirects,
  hideMigratingBannerOnDismiss,
  hideMigrationBannerOnDismiss,
  hideOPGBannerOnDismiss,
  hidePendingMigrationBannerOnDismiss,
  hideWorkspaceSelectionTeachingBubble,
  isAPICompatibilityEnabled,
  isExpManMigrated,
  isExperimentationGroupMigrated,
  isExperimentationGroupMigrating,
  isExperimentationGroupPendingMigration,
  isMDSMigrated,
  showMigratingBanner,
  showMigrationBannerOnRedirect,
  showMigrationRedirectBanner,
  showOPGSupportBanner,
  showPendingMigrationBanner,
  showWorkspaceSelectionTeachingBubble,
  showWorkspaceSelectionTeachingBubbleOnRedirect,
  stringCompareTo
};
//# sourceMappingURL=WorkspaceMigrationData.utils.js.map
